import * as reduxUtil from 'redux/utils/reducers';
import {
  GET_PAYOUT_TRACKER_PAGE_FAIL,
  GET_PAYOUT_TRACKER_PAGE_START,
  GET_PAYOUT_TRACKER_PAGE_SUCCESS
} from 'redux/constants/payoutTracker';

const initialState = {
  page: { ...reduxUtil.initializeObject(), timestamp: Date.now() }
};
export type IPayoutTrackerStore = typeof initialState;
const reducer = (state = initialState, action: Record<string, any>) => {
  const { data, error } = action?.payload || {};
  switch (action.type) {
    case GET_PAYOUT_TRACKER_PAGE_START:
      return reduxUtil.updateStartAction({ state, key: 'page' });
    case GET_PAYOUT_TRACKER_PAGE_SUCCESS:
      return reduxUtil.updateSuccessAction({ state, key: 'page', data });
    case GET_PAYOUT_TRACKER_PAGE_FAIL:
      return reduxUtil.updateFailAction({ state, key: 'page', error });
    default:
      return state;
  }
};
export default reducer;
